import { ISolicitacoes } from '../../../types/tables/ISolicitacoes';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

/**
 * Serviço para gerenciamento de solicitações de pagamento com isolamento multi-tenant
 * Gerencia solicitações geradas para cobrança (vinculadas às vendas)
 */
export class SolicitacoesService extends BaseMultiTenantService<ISolicitacoes> {
     constructor() {
          super(
               'solicitacoes', 
               ['numero_solicitacao', 'descricao_solicitacao'],
               'fk_id_organizacao'
          );
     }

     /**
      * Busca solicitação por número
      */
     async getByNumero(organizationId: number, numeroSolicitacao: number) {
          return await this.client
               .from('solicitacoes')
               .select(`
                    *,
                    sistema_origem (nome, codigo, prefixo)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('numero_solicitacao', numeroSolicitacao)
               .single();
     }

     /**
      * Busca solicitações por venda
      */
     async getByVenda(organizationId: number, vendaId: number) {
          return await this.client
               .from('solicitacoes')
               .select(`
                    *,
                    sistema_origem (nome, codigo, prefixo)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_venda', vendaId)
               .order('timestamp_criacao_solicitacao', { ascending: false });
     }

     /**
      * Busca solicitações por estado
      */
     async getByEstado(organizationId: number, codigoEstado: number) {
          return await this.client
               .from('solicitacoes')
               .select(`
                    *,
                    sistema_origem (nome, codigo, prefixo)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('codigo_estado_solicitacao', codigoEstado)
               .order('timestamp_criacao_solicitacao', { ascending: false });
     }

     /**
      * Busca solicitações pendentes
      */
     async getPendentes(organizationId: number) {
          return await this.client
               .from('solicitacoes')
               .select(`
                    *,
                    sistema_origem (nome, codigo, prefixo)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('codigo_estado_solicitacao', 0) // AGUARDANDO_PAGAMENTO
               .order('timestamp_criacao_solicitacao', { ascending: false });
     }

     /**
      * Busca solicitações expiradas
      */
     async getExpiradas(organizationId: number) {
          return await this.client
               .from('solicitacoes')
               .select(`
                    *,
                    sistema_origem (nome, codigo, prefixo)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('codigo_estado_solicitacao', 800) // EXPIRADA
               .order('timestamp_criacao_solicitacao', { ascending: false });
     }

     /**
      * Busca por código de conciliação
      */
     async getByConciliacao(organizationId: number, codigoConciliacao: string) {
          return await this.client
               .from('solicitacoes')
               .select(`
                    *,
                    sistema_origem (nome, codigo, prefixo)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('codigo_conciliacao_solicitacao', codigoConciliacao)
               .single();
     }
}
